<div class="use-desktop-app">
  <img src="assets/img/logo/logo-bisual-black.png" alt="bisual" width="200" class="logo" />

  <h1>Usa la app de escritorio</h1>
  <p class="message">
    El trabajo en proyectos, el fichaje y el resto de la intranet de producción requieren la app de escritorio. Desde el navegador puedes
    consultar y gestionar vacaciones, horario, nóminas y tu perfil.
  </p>

  <div class="actions">
    <a mat-stroked-button color="primary" [href]="desktopAppUrlDownload" target="_blank" rel="noopener noreferrer"> Descargar App </a>
    @if (openInAppLink(); as link) {
      <a mat-flat-button color="primary" [href]="link">Abrir en la app</a>
    }
    <button mat-stroked-button type="button" (click)="logout()">Cerrar sesión</button>
  </div>
</div>
